import * as THREE from 'three';
import { modelRefsRegistry } from '../stores/modelRefsRegistry';

// ============================================================
// G2：模型世界包围盒（优先真实渲染组；渲染组不可用时按 store 变换兜底）
// 兜底场景：无 WebGL / 模型尚未加载完成 / headless 预览
// ============================================================
export interface ModelBoxSource {
  id: string;
  position?: number[];
  scale?: number[];
}

export function modelWorldBox(m: ModelBoxSource): THREE.Box3 | null {
  const group = modelRefsRegistry.get(m.id)?.group ?? null;
  if (group) {
    const b = new THREE.Box3().setFromObject(group);
    if (!b.isEmpty() && b.min.toArray().every(Number.isFinite) && b.max.toArray().every(Number.isFinite)) return b;
  }
  const p = m.position ?? [0, 0, 0];
  const s = m.scale ?? [1, 1, 1];
  const hx = Math.abs(s[0]) || 1;
  const hy = Math.abs(s[1]) || 1;
  const hz = Math.abs(s[2]) || 1;
  if (![p[0], p[1], p[2]].every(Number.isFinite)) return null;
  return new THREE.Box3(
    new THREE.Vector3(p[0] - hx, p[1] - hy, p[2] - hz),
    new THREE.Vector3(p[0] + hx, p[1] + hy, p[2] + hz),
  );
}

export function projectBoxToClient(
  box: THREE.Box3,
  camera: THREE.Camera,
  canvas: HTMLCanvasElement,
): { left: number; top: number; right: number; bottom: number } | null {
  const bounds = canvas.getBoundingClientRect();
  const { min, max } = box;
  const corners = [
    new THREE.Vector3(min.x, min.y, min.z),
    new THREE.Vector3(min.x, min.y, max.z),
    new THREE.Vector3(min.x, max.y, min.z),
    new THREE.Vector3(min.x, max.y, max.z),
    new THREE.Vector3(max.x, min.y, min.z),
    new THREE.Vector3(max.x, min.y, max.z),
    new THREE.Vector3(max.x, max.y, min.z),
    new THREE.Vector3(max.x, max.y, max.z),
  ];
  let left = Infinity;
  let top = Infinity;
  let right = -Infinity;
  let bottom = -Infinity;
  for (const c of corners) {
    const p = c.clone().project(camera);
    if (!Number.isFinite(p.x) || !Number.isFinite(p.y)) continue;
    const sx = bounds.left + ((p.x + 1) / 2) * bounds.width;
    const sy = bounds.top + ((-p.y + 1) / 2) * bounds.height;
    left = Math.min(left, sx);
    right = Math.max(right, sx);
    top = Math.min(top, sy);
    bottom = Math.max(bottom, sy);
  }
  if (!Number.isFinite(left)) return null;
  return { left, top, right, bottom };
}
